import { ONBOARDING_PARTICIPANT_ROLES } from "../../../shared/config";

export const DECLARED_INCOME = {
  EDIT_INCOME_FORM: "EDIT_INCOME_FORM",
  SET_BANK_ACCOUNT: "SET_BANK_ACCOUNT",
};

export const DECLARED_INCOME_ON_CONDITIONS = {
  EDIT_INCOME_FORM: "EDIT_INCOME_FORM",
  SET_BANK_ACCOUNT: "SET_BANK_ACCOUNT",
};

export const netIncomeTypesConfig = {
  SALARY: {
    name: "SALARY",
    value: "salary",
  },
  PENSION: {
    name: "PENSION",
    value: "pension",
  },
  UNEMPLOYMENT_BENEFIT: {
    name: "UNEMPLOYMENT_BENEFIT",
    value: "unemployment_benefit",
  },
  OTHER_PAYMENT: {
    name: "OTHER_PAYMENT",
    value: "other_payment",
  },
};

export const netIncomeTypesWithoutOtherConfig = {
  SALARY: {
    name: "SALARY",
    value: "salary",
  },
  PENSION: {
    name: "PENSION",
    value: "pension",
  },
  UNEMPLOYMENT_BENEFIT: {
    name: "UNEMPLOYMENT_BENEFIT",
    value: "unemployment_benefit",
  },
};

export const DOCUMENT_ID_TYPES = {
  NIF: "nif",
  NIE_EU: "nie_eu",
  NIE_NON_EU: "nie_non_eu",
  PASSPORT: "passport",
};

export const ALLOWED_PARTICIPANT_ROLES_FOR_SET_BANK_ACCOUNT_STEP = [
  ONBOARDING_PARTICIPANT_ROLES.BORROWER,
];

export const isSetBankAccountStepAllowedByRole = (participant) =>
  ALLOWED_PARTICIPANT_ROLES_FOR_SET_BANK_ACCOUNT_STEP.some(
    (role) => role === participant.role
  );
